export const checkForSlug = <T extends { slug: string | null; contentful_id?: string | null }>(
  item: T | null,
  typename?: string
): boolean => {
  if (item?.slug) {
    return true;
  } else {
    typename &&
      console.log(
        `> WARNING: an item of type ${typename} had no slug. ` +
          (item?.contentful_id && `Contentful id: ${item?.contentful_id}`)
      );
    return false;
  }
};
